<ng-container *ngIf="generalSettingsData" #pageDataContainer>
    <app-header [generalSettingsData]="generalSettingsData" (openSidebar)="toggleSidebar(true)"></app-header>

    <div class="page-container">
        <div class="sidebar-overlay" [ngClass]="{ opened: openedSidebar }"></div>

        <app-sidebar [generalSettingsData]="generalSettingsData" [opened]="openedSidebar"
            (close)="toggleSidebar(false)"></app-sidebar>

        <div class="page-main">
            <div [innerHTML]="generalSettingsData.promotedMessagesSection.html | safeHtml"></div>
            <div class="page-content-wrap">
                <div class="page-content">
                    <ng-container *ngIf="pageData" [ngSwitch]="pageData.name">
                        <app-home-page *ngSwitchCase="PreviewPageType.PortalHomePage" [pageUrl]="pageData.url"></app-home-page>
                        <app-catalog-page *ngSwitchCase="PreviewPageType.PortalCatalogPage" [pageUrl]="pageData.url"></app-catalog-page>
                        <app-catalog-page *ngSwitchCase="PreviewPageType.UnitsPortalCatalogFolder" [pageUrl]="pageData.url" [childNodeId]="nodeId"></app-catalog-page>
                        <app-standard-content-page *ngSwitchCase="PreviewPageType.PortalStandardContentPage" [isPreview]="true" [pageUrl]="pageData.url"></app-standard-content-page>
                        <app-department-info-page *ngSwitchCase="PreviewPageType.PortalDepartmentInfo" [pageTitle]="pageData.title" [pageNodeId]="nodeId" [pageUrl]="pageData.url"></app-department-info-page>
                        <app-department-info-page *ngSwitchCase="PreviewPageType.DepartmentInfo" [pageTitle]="pageData.title" [departmentInfoId]="nodeId"></app-department-info-page>
                        <app-career-lobby-page *ngSwitchCase="PreviewPageType.CareerLobbyPage" [pageUrl]="pageData.url"></app-career-lobby-page>
                        <app-events-lobby-page *ngSwitchCase="PreviewPageType.PortalEventsPage" [pageUrl]="pageData.url"></app-events-lobby-page>
                        <app-articles-and-news-page *ngSwitchCase="PreviewPageType.PortalArticlesPage" [pageUrl]="pageData.url"></app-articles-and-news-page>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-container>